import { Injectable, Signal, effect, inject } from "@angular/core";
import { Simulation, TypeProduit } from "@mra/hlp9002";
import { userStore } from "src/app/state/user.store";
@Injectable({
  providedIn: "root"
})
export class ThemeService {
  private readonly userStore = inject(userStore);

  simulation: Signal<Simulation> = this.userStore.simulation;

  watchTheme() {
    effect(() => {
      const simu: Simulation = this.simulation();
      this.updateTheme(simu?.typeProduit);
    });
  }

  /**
   * met à jour le thème
   * @param typeProduit type de produit
   */
  private updateTheme(typeProduit: TypeProduit) {
    document.body.setAttribute("data-theme", typeProduit === TypeProduit.PTS ? "crh" : "allianz");
  }

  /**
   * récupère la couleur principale du thème actuellement appliqué
   * @returns code css de la couleur
   */
  getMainColor(): string {
    return getComputedStyle(document.body).getPropertyValue("--interactive-primary");
  }
}
